import { Fragment } from 'react'
import AppStyleDecider from '../../../../../../../../../../baseComponents/AppsStyleDecider'
import { OrderStepButtonsBaseComponentProps } from '../../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/OrderButtonsBaseComponent/types'
import BuyDeliveryNoteStatusBar, { BuyDeliveryNoteStatusBarNew, DeliveryNoteCreateStatusBarProps } from '../../../BuyDeliveryNoteStatusBar'
import BuyDeliveryNoteWaitingResponseStepButtons, { BuyDeliveryNoteWaitingResponseStepButtonsNew } from '../BuyDeliveryNoteWaitingResponseStepButtons'

type BuyDeliveryNoteWaitingResponseStepHeaderProps = & DeliveryNoteCreateStatusBarProps & OrderStepButtonsBaseComponentProps

const BuyDeliveryNoteWaitingResponseStepHeaderDecider: React.FC<BuyDeliveryNoteWaitingResponseStepHeaderProps> = ({ ...rest }) => {
    return (
        <AppStyleDecider DefaultComponent={BuyDeliveryNoteWaitingResponseStepHeaderDefault} NewComponent={BuyDeliveryNoteWaitingResponseStepHeaderNew} {...rest} />
    )
}

const BuyDeliveryNoteWaitingResponseStepHeaderDefault: React.FC<BuyDeliveryNoteWaitingResponseStepHeaderProps> = ({ ...rest }) => {
    return (
        <div className='flex gap-10 justify-between flex-wrap items-center flex-auto'>
            <BuyDeliveryNoteStatusBar {...rest} />
            <BuyDeliveryNoteWaitingResponseStepButtons {...rest} />
        </div>
    )
}

const BuyDeliveryNoteWaitingResponseStepHeaderNew: React.FC<BuyDeliveryNoteWaitingResponseStepHeaderProps> = ({ ...rest }) => {
    return (
        <Fragment>
            <BuyDeliveryNoteStatusBarNew {...rest} />
            <BuyDeliveryNoteWaitingResponseStepButtonsNew {...rest} />
        </Fragment>
    )
}

export default BuyDeliveryNoteWaitingResponseStepHeaderDecider